/**
 * Per-card copy-limit exceptions for deck construction.
 *
 * Default is DECK_LIMITS.MAX_COPIES (3) across champion + main deck + sideboard.
 * Cards listed here override that. Zone size limits (main 40 / sideboard 10) still apply.
 *
 * Matching uses exact card name (trimmed), same convention as the ban list —
 * names are the stable identifier shared by RiftboundCard and DeckCardRef.
 *
 * Add new exceptions here when cards print "Your deck can have any number of…"
 * (or a non-default finite cap). Keep api/_shared/deckCopyLimits.js in sync.
 */

export type DeckCopyLimitException =
  /** No per-name copy cap (zone sizes still bind). */
  | { kind: 'unlimited' }
  /** Explicit finite override of the default 3-copy rule. */
  | { kind: 'max'; max: number };

/** Cards that ignore or change the standard 3-copy rule. Key = exact card name. */
export const DECK_COPY_LIMIT_EXCEPTIONS: ReadonlyMap<string, DeckCopyLimitException> = new Map([
  // VEN 097 — "Your deck can have any number of cards named Spiderling."
  ['Spiderling', { kind: 'unlimited' }],
]);
